<template>
  <div class="range-input-container">
    <!-- 第一个数值输入框 -->
    <el-input
      v-model="leftValue"
      size="small"
      class="text-input"
      placeholder="最小值"
      @input="handleValueChange"
      @blur="handleValueChange"
    />
    
    <!-- 中间操作符选择 -->
    <el-select v-model="operator" size="small" class="operator-select" @change="handleValueChange">
      <el-option label="<" value="<"></el-option>
      <el-option label="≤" value="≤"></el-option>
      <el-option label="=" value="="></el-option>
      <el-option label="≥" value="≥"></el-option>
      <el-option label=">" value=">"></el-option>
      <el-option label="-" value="-"></el-option>
    </el-select>
    
    <!-- 第二个数值输入框 -->
    <el-input
      v-model="rightValue"
      size="small"
      class="text-input"
      placeholder="最大值"
      @input="handleValueChange"
      @blur="handleValueChange"
    />
  </div>
</template>

<script>
export default {
  name: 'RangeInput',
  props: {
    // 当前值
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      leftValue: null,
      operator: '-', // 默认区间操作符
      rightValue: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.parseValue(newVal)
      }
    }
  },
  methods: {
    /**
     * 解析传入的值
     * @param {string} value - 要解析的值
     */
    parseValue(value) {
      if (!value) {
        this.resetValues()
        return
      }

      // 判断是单值还是区间
      if (value.includes('-')) {
        // 区间格式：如 "18.5 - 23.9"
        this.parseRangeValue(value)
      } else {
        // 单值格式：如 "< 18.5" 或 "≥ 25"
        this.parseSingleValue(value)
      }
    },

    /**
     * 解析单值
     * @param {string} value - 单值字符串
     */
    parseSingleValue(value) {
      const match = value.match(/^([<≤=≥>])\s*([\d.]+)$/)
      if (match) {
        this.operator = match[1]
        this.leftValue = match[2]
        this.rightValue = ''
      }
    },

    /**
     * 解析区间值
     * @param {string} value - 区间字符串
     */
    parseRangeValue(value) {
      // 处理格式如 "18.5 - 23.9"
      const parts = value.split('-')
      if (parts.length === 2) {
        // 解析左值
        const leftMatch = parts[0].match(/^([<≤]?)\s*([\d.]+)$/)
        if (leftMatch) {
          this.leftValue = leftMatch[2]
        } else {
          this.leftValue = parts[0].trim()
        }

        // 解析右值
        const rightMatch = parts[1].match(/^([<≤]?)\s*([\d.]+)$/)
        if (rightMatch) {
          this.rightValue = rightMatch[2]
        } else {
          this.rightValue = parts[1].trim()
        }

        this.operator = '-'
      }
    },

    /**
     * 重置所有值
     */
    resetValues() {
      this.leftValue = ''
      this.rightValue = ''
      this.operator = '-'
    },

    /**
     * 处理数值变化
     */
    handleValueChange() {
      this.emitValue()
    },

    /**
     * 生成并发送值
     */
    emitValue() {
      let result = ''
      
      if (this.operator === '-') {
        // 区间模式
        if (this.leftValue && this.rightValue) {
          result = `${this.leftValue} - ${this.rightValue}`
        }
      } else {
        // 单值模式
        if (this.leftValue) {
          result = `${this.operator} ${this.leftValue}`
        }
      }

      this.$emit('input', result)
      this.$emit('change', result)
    }
  }
}
</script>

<style scoped>
.range-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.text-input {
  flex: 1;
  min-width: 80px;
}

.operator-select {
  width: 60px;
  flex-shrink: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .range-input-container {
    flex-direction: column;
    gap: 8px;
  }
  
  .text-input,
  .operator-select {
    width: 100%;
  }
}
</style>
